import { IShellDAO } from '../../dao/IShellDAO';
import { GrantType } from './types';
import { AbstractRepository } from '../../core/repositories/AbstractRepository';
import { internalLogger } from '../../interface/v1/clientOsLogger';

export class PendingGrantRepository extends AbstractRepository<GrantType[]> {
  constructor({
    shellDAO,
    enableSanitizer = false
  }: {
    shellDAO: IShellDAO;
    enableSanitizer?: boolean;
  }) {
    super({
      shellDAO: shellDAO,
      prefixKey: 'jshellPendingGrants',
      enableSanitizer
    });
  }

  saveAll(): void {
    /* istanbul ignore next */
    internalLogger?.debug?.d5?.({
      className: 'PendingGrantRepository',
      methodName: 'saveAll()',
      message: 'Not supported in PendingGrantRepository.'
    });
    throw new Error('Method not implemented.');
  }

  findAll(): GrantType[][] {
    /* istanbul ignore next */
    internalLogger?.debug?.d5?.({
      className: 'PendingGrantRepository',
      methodName: 'findAll()',
      message: 'Not supported in PendingGrantRepository.'
    });
    throw new Error('Method not implemented.');
  }

  delete(): boolean {
    /* istanbul ignore next */
    internalLogger?.debug?.d5?.({
      className: 'PendingGrantRepository',
      methodName: 'delete()',
      message: 'Not supported in PendingGrantRepository.'
    });
    throw new Error('Method not implemented.');
  }
}
